import styled from "styled-components";

export const StyledModal = styled.div`
  .modal-container {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #ffffffb3;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal-wrap {
      width: max-content;
      height: 270px;
      background-color: #fff;
      box-shadow: 0px 4px 10px 0px rgba(62, 44, 90, 0.08);
      border-radius: 4px;
      overflow: hidden;
      .title-wrap {
        width: calc(100% - 32px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        background-color: #fafafb;
        .title {
          font-size: 18px;
          font-weight: 700;
        }
        .close-btn {
          box-sizing: content-box;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 14px;
          height: 14px;
          padding: 4px;
          border: none;
          outline: none;
          background-color: transparent;
          cursor: pointer;
        }
      }
      .main-wrap {
        width: max-content;
        height: max-content;
        padding: 16px;
        padding-bottom: 40px;
      }
      .footer-wrap {
        width: calc(100% - 32px);
        height: max-content;
        display: flex;
        padding: 16px;
        padding-top: 0;
        justify-content: flex-end;
        & > button {
          border: none;
          padding: 7px 18px;
          background-color: #4679cc;
          color: #fff;
          font-size: 14px;
          font-weight: 300;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }
  }
`;
